import { useFeatureFlags } from 'utils/features';

export default function useSafetyInspectionsEnabled() {
  return useFeatureFlags('SAFETY_INSPECTIONS');
}
